import Api from '../Utils/Axios';

export const GetContactUsList = async (data) => {
  const response = await Api.post(`admin/contact-us/list`, data);
  return response.data;
};
